// extracted by mini-css-extract-plugin
export var leftImage = "ModalContainer_leftImage__34loX";
export var md = "768px";
export var modalContainer = "ModalContainer_modalContainer__hWVpL";
export var modalOverlay = "ModalContainer_modalOverlay__ncMa3";
export var modalWrapper = "ModalContainer_modalWrapper__HtM-I";
export var shared = "'../../../../../shared.module.css'";
export var topImage = "ModalContainer_topImage__5kQmB";